/**
 * Pure derivation of the vault page's UI state from observable inputs.
 *
 * Kept separate from the React component so the switch can be tested without
 * a DOM. The component itself just renders whichever sub-tree this returns.
 *
 * - `claiming`  — explicit multi-step claim flow is in flight (show animation).
 * - `connecting` — wallet not yet connected, or vault GET in flight (silent).
 * - `empty`     — vault resolved, no agents connected.
 * - `claimed`   — vault resolved, at least one agent.
 */

export type VaultUiState = 'claiming' | 'connecting' | 'empty' | 'claimed';

export interface VaultStateInputs {
  walletConnected: boolean;
  /** True only while the multi-step claim flow is mid-flight. */
  claiming: boolean;
  /** Resolved vault id, or null if no vault has been fetched/claimed yet. */
  vaultId: string | null;
  agentCount: number;
}

export function deriveVaultState(i: VaultStateInputs): VaultUiState {
  if (i.claiming) return 'claiming';
  if (!i.walletConnected || !i.vaultId) return 'connecting';
  if (i.agentCount > 0) return 'claimed';
  return 'empty';
}
